export default { suggestionListItemText: { marginLeft: '1rem' } };

